import { AppAnalytics, PageViewed } from '../../Analytics';
import { PAGE_NAME } from '../../eventNames';

const pageName = window.pageName;

const pageViewEvents = {
  reportListView: (page_referrer = '', pageContext = {}) => {
    const context = { ...pageContext };
    const referrer = page_referrer.length > 0 ? page_referrer : pageName;
    AppAnalytics.reportEvent(new PageViewed(PAGE_NAME.REPORT_LIST_VIEW, referrer, context));
  },

  reportStoryView: (pageContext = {}) => {
    const context = { ...pageContext };
    AppAnalytics.reportEvent(
      new PageViewed(PAGE_NAME.REPORT_STORY_VIEW, pageName || PAGE_NAME.REPORT_LIST_VIEW, context)
    );
  },

  reportVideoView: (pageContext = {}) => {
    const context = { ...pageContext };
    AppAnalytics.reportEvent(
      new PageViewed(PAGE_NAME.REPORT_VIDEO_VIEW, pageName || PAGE_NAME.REPORT_LIST_VIEW, context)
    );
  },

  carePlan: (pageContext = {}) => {
    const context = { ...pageContext };
    AppAnalytics.reportEvent(
      new PageViewed(PAGE_NAME.CARE_PLAN, pageName || PAGE_NAME.REPORT_VIDEO_VIEW, context)
    );
  },

  videoLoaded: (page_referrer = '', pageContext = {}) => {
    const context = { ...pageContext };
    AppAnalytics.reportEvent(
      new PageViewed(PAGE_NAME.VIDEO_LOADED, pageName || page_referrer, context)
    );
  },

  videoPlayBackStarted: (page_referrer = '', pageContext = {}) => {
    const context = { ...pageContext };
    AppAnalytics.reportEvent(
      new PageViewed(PAGE_NAME.VIDEO_PLAYBACK_START, pageName || page_referrer, context)
    );
  },

  videoPlayBackError: (page_referrer = '', pageContext = {}) => {
    const context = { ...pageContext };
    AppAnalytics.reportEvent(
      new PageViewed(PAGE_NAME.VIDEO_PLAYBACK_ERROR, pageName || page_referrer, context)
    );
  },

  videoComponentLoaded: (page_referrer = '', pageContext = {}) => {
    const context = { ...pageContext };
    AppAnalytics.reportEvent(
      new PageViewed(PAGE_NAME.VIDEO_COMPONENT_LOADED, pageName || page_referrer, context)
    );
  },

  videoLoadStarted: (page_referrer = '', pageContext = {}) => {
    const context = { ...pageContext };
    AppAnalytics.reportEvent(
      new PageViewed(PAGE_NAME.VIDEO_LOAD_STARTED, pageName || page_referrer, context)
    );
  },

  videoBuffering: (page_referrer = '', pageContext = {}) => {
    const context = { ...pageContext };
    AppAnalytics.reportEvent(
      new PageViewed(PAGE_NAME.VIDEO_BUFFERING, pageName || page_referrer, context)
    );
  },

  videoStalled: (page_referrer = '', pageContext = {}) => {
    const context = { ...pageContext };
    AppAnalytics.reportEvent(
      new PageViewed(PAGE_NAME.VIDEO_STALLED, pageName || page_referrer, context)
    );
  },

  videoPlaying: (page_referrer = '', pageContext = {}) => {
    const context = { ...pageContext };
    AppAnalytics.reportEvent(
      new PageViewed(PAGE_NAME.VIDEO_PLAYING, pageName || page_referrer, context)
    );
  },

  videoLoadSuspended: (page_referrer = '', pageContext = {}) => {
    const context = { ...pageContext };
    AppAnalytics.reportEvent(
      new PageViewed(PAGE_NAME.VIDEO_LOAD_SUSPENDED, pageName || page_referrer, context)
    );
  },

  videoError: (page_referrer = '', pageContext = {}) => {
    const context = { ...pageContext };
    AppAnalytics.reportEvent(
      new PageViewed(PAGE_NAME.VIDEO_ERRORED, pageName || page_referrer, context)
    );
  },

  videoCanPlay: (page_referrer = '', pageContext = {}) => {
    const context = { ...pageContext };
    AppAnalytics.reportEvent(
      new PageViewed(PAGE_NAME.VIDEO_CAN_PLAY, pageName || page_referrer, context)
    );
  },

  videoViewedCompletely: (page_referrer = '', pageContext = {}) => {
    const context = { ...pageContext };
    AppAnalytics.reportEvent(
      new PageViewed(PAGE_NAME.VIDEO_VIEWED_COMPLETELY, pageName || page_referrer, context)
    );
  },

  storyGroupCompleted: (pageContext = {}) => {
    let context = { ...pageContext };
    const { section } = pageContext;
    if (section === 'video') {
      const videoContext = prepareVideoEventContext();
      context = { ...context, ...videoContext };
    }
    AppAnalytics.reportEvent(
      new PageViewed(`${section} Completed`, pageName || PAGE_NAME.REPORT_STORY_VIEW, context)
    );
  },

  scrolledToBottom: (pageContext = {}) => {
    const context = { ...pageContext };
    AppAnalytics.reportEvent(
      new PageViewed(PAGE_NAME.SCROLLED_TO_BOTTOM, pageName || PAGE_NAME.REPORT_LIST_VIEW, context)
    );
  },

  loginSignup: (page_referrer = '', pageContext = {}) => {
    const context = { ...pageContext };
    AppAnalytics.reportEvent(
      new PageViewed(PAGE_NAME.LOGIN_SIGNUP, pageName || page_referrer, context)
    );
  },

  reportViewInferenceSectionViewed: (pageContext = {}) => {
    const context = { ...pageContext };
    AppAnalytics.reportEvent(
      new PageViewed(
        PAGE_NAME.INFERENCE_SECTION_VIEWED,
        pageName || PAGE_NAME.REPORT_LIST_VIEW,
        context
      )
    );
  },

  reportViewGASectionViewed: (pageContext = {}) => {
    const context = { ...pageContext };
    AppAnalytics.reportEvent(
      new PageViewed(
        PAGE_NAME.GENERAL_ADVICE_SECTION_VIEWED,
        pageName || PAGE_NAME.REPORT_LIST_VIEW,
        context
      )
    );
  },

  reportViewRedFlagsSectionViewed: (pageContext = {}) => {
    const context = { ...pageContext };
    AppAnalytics.reportEvent(
      new PageViewed(
        PAGE_NAME.RED_FLAGS_SECTION_VIEWED,
        pageName || PAGE_NAME.REPORT_LIST_VIEW,
        context
      )
    );
  },

  reportViewBannerSectionViewed: (pageContext = {}) => {
    const context = { ...pageContext };
    AppAnalytics.reportEvent(
      new PageViewed(
        PAGE_NAME.BANNER_SECTION_VIEWED,
        pageName || PAGE_NAME.REPORT_LIST_VIEW,
        context
      )
    );
  },

  reportViewCarouselSectionViewed: (pageContext = {}) => {
    const context = { ...pageContext };
    AppAnalytics.reportEvent(
      new PageViewed(
        PAGE_NAME.CAROUSEL_SECTION_VIEWED,
        pageName || PAGE_NAME.REPORT_LIST_VIEW,
        context
      )
    );
  },

  reportViewCTCarouselSectionViewed: (pageContext = {}) => {
    const context = { ...pageContext };
    AppAnalytics.reportEvent(
      new PageViewed(
        PAGE_NAME.CARETEAM_CAROUSEL_SECTION_VIEWED,
        pageName || PAGE_NAME.REPORT_LIST_VIEW,
        context
      )
    );
  },

  reportViewVideoSectionViewed: (pageContext = {}) => {
    const context = { ...pageContext };
    AppAnalytics.reportEvent(
      new PageViewed(
        PAGE_NAME.VIDEO_SECTION_VIEWED,
        pageName || PAGE_NAME.REPORT_LIST_VIEW,
        context
      )
    );
  },

  reportViewDisclaimerSectionViewed: (pageContext = {}) => {
    const context = { ...pageContext };
    AppAnalytics.reportEvent(
      new PageViewed(
        PAGE_NAME.DISCLAIMER_SECTION_VIEWED,
        pageName || PAGE_NAME.REPORT_LIST_VIEW,
        context
      )
    );
  },

  reportViewAdvicesSectionViewed: (pageContext = {}) => {
    const context = { ...pageContext };
    AppAnalytics.reportEvent(
      new PageViewed(PAGE_NAME.ADVICES_SECTION_VIEWED, PAGE_NAME.REPORT_LIST_VIEW, context)
    );
  },

  reportViewDiagnosisSectionViewed: (pageContext = {}) => {
    const context = { ...pageContext };
    AppAnalytics.reportEvent(
      new PageViewed(PAGE_NAME.DIAGNOSIS_SECTION_VIEWED, PAGE_NAME.REPORT_LIST_VIEW, context)
    );
  },

  reportViewRecommendationSectionViewed: (pageContext = {}) => {
    const context = { ...pageContext };
    AppAnalytics.reportEvent(
      new PageViewed(PAGE_NAME.RECOMMENDATION_SECTION_VIEWED, PAGE_NAME.REPORT_LIST_VIEW, context)
    );
  },

  reportViewPackageSectionViewed: (pageContext = {}) => {
    const context = { ...pageContext };
    AppAnalytics.reportEvent(
      new PageViewed(PAGE_NAME.PACKAGE_SECTION_VIEWED, PAGE_NAME.REPORT_LIST_VIEW, context)
    );
  },

  reportViewProductFeaturesSectionViewed: (pageContext = {}) => {
    const context = { ...pageContext };
    AppAnalytics.reportEvent(
      new PageViewed(PAGE_NAME.PRODUCT_FEATURES_SECTION_VIEWED, PAGE_NAME.REPORT_LIST_VIEW, context)
    );
  },

  reportViewJourneySectionViewed: (pageContext = {}) => {
    const context = { ...pageContext };
    AppAnalytics.reportEvent(
      new PageViewed(PAGE_NAME.JOURNEY_SECTION_VIEWED, PAGE_NAME.REPORT_LIST_VIEW, context)
    );
  },

  reportViewConsultSectionViewed: (pageContext = {}) => {
    const context = { ...pageContext };
    AppAnalytics.reportEvent(
      new PageViewed(PAGE_NAME.CONSULT_SECTION_VIEWED, PAGE_NAME.REPORT_LIST_VIEW, context)
    );
  },

  reportViewTestimonialsSectionViewed: (pageContext = {}) => {
    const context = { ...pageContext };
    AppAnalytics.reportEvent(
      new PageViewed(PAGE_NAME.TESTIMONIALS_SECTION_VIEWED, PAGE_NAME.REPORT_LIST_VIEW, context)
    );
  },

  reportViewSkincareAdviceSectionViewed: (pageContext = {}) => {
    const context = { ...pageContext };
    AppAnalytics.reportEvent(
      new PageViewed(PAGE_NAME.SK_ADVICE_SECTION_VIEWED, PAGE_NAME.REPORT_LIST_VIEW, context)
    );
  },

  reportViewSkincareRoutineSectionViewed: (pageContext = {}) => {
    const context = { ...pageContext };
    AppAnalytics.reportEvent(
      new PageViewed(PAGE_NAME.SK_ROUTINE_SECTION_VIEWED, PAGE_NAME.REPORT_LIST_VIEW, context)
    );
  },

  productKitViewed: (pageContext = {}) => {
    const context = { ...pageContext };
    AppAnalytics.reportEvent(
      new PageViewed(PAGE_NAME.PRODUCT_KIT_VIEWED, PAGE_NAME.REPORT_LIST_VIEW, context)
    );
  },

  shareReportSectionViewed: (pageContext = {}) => {
    const context = { ...pageContext };
    AppAnalytics.reportEvent(
      new PageViewed(
        PAGE_NAME.SHARE_REPORT_SECTION_VIEWED,
        pageName || PAGE_NAME.REPORT_LIST_VIEW,
        context
      )
    );
  },

  tabSectionViewed: (pageContext = {}) => {
    const context = { ...pageContext };
    AppAnalytics.reportEvent(
      new PageViewed(PAGE_NAME.TAB_SECTION_VIEWED, pageName || PAGE_NAME.REPORT_LIST_VIEW, context)
    );
  },

  pdfFromReportsLandingPage: (pageContext = {}) => {
    const context = { ...pageContext };
    AppAnalytics.reportEvent(
      new PageViewed(
        PAGE_NAME.PDF_LANDING_PAGE_FROM_REPORTS_VIEWED,
        PAGE_NAME.PDF_LANDING_PAGE,
        context
      )
    );
  },
};

export default pageViewEvents;

const prepareVideoEventContext = () => {
  try {
    const videoPlayer = document.getElementById('myVideo'); //Added this purely for event purpose, need to change this in future
    const currentTime = parseInt(videoPlayer.currentTime);
    const totalDuration = parseInt(videoPlayer.duration);
    const percentageVideoPlayed = parseInt((currentTime / totalDuration) * 100);
    return { currentTime, totalDuration, percentageVideoPlayed };
  } catch (error) {
    console.error('Error in video context ::', error);
  }
};
